export default "__VITE_ASSET__BOQ356H6__"